import React, { useRef } from "react";
import { Modal as ReactModal } from "react-bootstrap";
import Button from "../../components/Button";
import "../../globals/scss/components/modal.scss";
import PropTypes from "prop-types";
import ReactToPrint, {useReactToPrint} from "react-to-print";

const propTypes = {
  /** Name of component class */
  className: PropTypes.string,
  /** When true the modal will show itself. */
  show: PropTypes.bool,
  /** A callback fired when the header closeButton or
   * non-static backdrop is clicked. Required if either
   *  are specified. */
  onHide: PropTypes.func,
  /** The header of Modal */
  header: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
    PropTypes.object,
  ]),
  // PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** The body of Modal */
  body: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
    PropTypes.object,
  ]),
  // PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** The footer of Modal - Default footer is a Close button */
  footer: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
    PropTypes.object,
  ]),
  // PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /** Don't show the header closeButton */
  hideclosebutton: PropTypes.string,
  /** Show the printButton on the footer */
  showprintbutton: PropTypes.bool
};

const Modal = (props) => {
  const componentRef = useRef()
  const { onHide, header, body, footer, hideclosebutton, showprintbutton } = props;

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const getDefaultFooter = (onClick) => (
    <>
      <Button variant="text" onClick={onClick}>
        <span className="material-icons">close</span>
        <span className="button__text">Close</span>
      </Button>

      {showprintbutton ? (
        <Button variant="text" onClick={handlePrint}>
          <span className="material-icons">print</span>
          <span className="button__text">Print</span>
        </Button>
      ) : (
        <></>
      )}
    </>
  );

  return (
    <>
      <ReactModal {...props}>
        {hideclosebutton === "true" ? (
          <ReactModal.Header>{header}</ReactModal.Header>
        ) : (
          <ReactModal.Header closeButton>{header}</ReactModal.Header>
        )}
        <ReactModal.Body ref={componentRef}>{body}</ReactModal.Body>
        <ReactModal.Footer>
          {footer ? footer : getDefaultFooter(onHide)}
        </ReactModal.Footer>
      </ReactModal>
    </>
  );
};

Modal.propTypes = propTypes
Modal.Title = ReactModal.Title
Modal.Body = ReactModal.Body
Modal.Header = ReactModal.Header
Modal.Footer = ReactModal.Footer
Modal.Dialog = ReactModal.Dialog

export default Modal
